module.exports = __webpack_public_path__ + "static/media/playstore-icon.0d30fe29.png";


//////////////////
// WEBPACK FOOTER
// ./src/Resources/Images/playstore-icon.png
// module id = 63
// module chunks = 0